var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinearBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 244,
    viewBox: "0 0 360 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 240,
    fill: "url(#paint0_linear_265_1413)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.78 7.26589C155.686 -89.5776 263.484 -76.9377 315.328 -51.8275C367.171 -26.7173 407.79 -16.5855 360.884 80.2579C313.978 177.101 70.7423 264.125 18.8991 239.015C-32.9441 213.904 61.8739 104.109 108.78 7.26589Z",
    fill: "url(#paint1_linear_265_1413)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-24.5001 -5.50037C-0.145295 -110.313 107.782 -121.798 163.892 -108.76C220.001 -95.7219 261.855 -94.8131 237.5 9.99948C213.145 114.812 -4.85865 253.416 -60.9679 240.378C-117.077 227.34 -48.855 99.3122 -24.5001 -5.50037Z",
    fill: "url(#paint2_linear_265_1413)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_265_1413",
    x1: 360,
    y1: 120,
    x2: -0.0000122708,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B225F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E40E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_265_1413",
    x1: 75.2495,
    y1: 49.0088,
    x2: 318.868,
    y2: 167.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B225F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E40E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_265_1413",
    x1: -47.9813,
    y1: 42.6182,
    x2: 215.684,
    y2: 103.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B225F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E40E41"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinearBg);
export default __webpack_public_path__ + "static/media/LinearBg.24abfb3e594c742d165361a098c49b0c.svg";
export { ForwardRef as ReactComponent };